<template>
    <VJoyTemplate full sidebar="right">
        <template #template-main>
            <VJoyTemplate full sidebar="left">
                <template #template-main>
                    <CookiePolicy />
                </template>
                <template #template-sidebar>
                    <Sidebar current-link="cookies" />
                </template>
            </VJoyTemplate>
        </template>
    </VJoyTemplate>
</template>
<script setup lang="ts">
    import {definePageMeta, useTwitterMetaTags, TwitterMetaTags, useOpenGraphMetaTags, OpenGraphMetaTag, useSeoMeta, useTranslation} from '#imports';
    import {VJoyTemplate} from '@maltjoy/core-vue';
    import Sidebar from '~/components/content/Sidebar.vue';
    import CookiePolicy from '~/components/CookiePolicy.vue';
    // import CookiePolicyByCategory from '~/components/CookiePolicyByCategory.vue';

    const {t} = useTranslation();

    useTwitterMetaTags(
        new TwitterMetaTags({
            card: 'summary',
            title: t('gdpr.title.cookies'),
            description: t('gdpr.meta.desc.cookies'),
            t,
        }),
    );
    useOpenGraphMetaTags(
        new OpenGraphMetaTag({
            title: t('gdpr.title.cookies'),
            description: t('gdpr.meta.desc.cookies'),
            t,
        }),
    );

    useSeoMeta({
        title: t('gdpr.title.cookies'),
        description: t('gdpr.meta.desc.cookies'),
    });

    definePageMeta({
        layout: 'content',
    });
</script>
